module.exports = __webpack_public_path__ + "static/media/ils-card-scan.730d2c19.svg";